import type { IconProps } from "./icon-types";

/**
 * 꺾은선 그래프(line chart). 지표/추이/대시보드 진입점에서 사용.
 *
 * VS Code의 `VscGraphLine`(codicon) path를 인라인으로 재현 —
 * c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 * codicon 원본을 그대로 사용하므로 16 그리드 / fill 기반.
 */
export const GraphLineIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="currentColor"
    aria-hidden="true"
    {...props}
  >
    <path d="M15 13V14H1.5L1 13.5V0H2V13H15Z" />
    <path d="M13 3.20714L7.85353 8.35359H7.14642L5.49998 6.70714L1.85353 10.3536L1.14642 9.64648L5.14642 5.64648H5.85353L7.49998 7.29293L12.6464 2.14648H13.3535L15.3535 4.14648L14.6464 4.85359L13 3.20714Z" />
  </svg>
);
